/**
 * v4 entry (loaded by v4.html, only in VITE_APP_MODE=v4 builds). Deliberately loads NONE of
 * the legacy Hub stylesheets or Bootstrap: v4 takes all styling from src/ds.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';
import { GoogleAuthProvider } from '@/auth/GoogleAuthContext';
import { installGoogleApiAuth } from '@/auth/googleApiAuth';
import { appConfig } from '@/utils/config';
import { ToastProvider } from '@/ds';
import '@/ds/ds.css';
import { Suspense, lazy } from 'react';
// Build-time switch: the hub (v4) or the standalone redesigned PQ app (pq4). Vite replaces
// the mode with a literal, so the other app is dropped from the bundle.
const Root = import.meta.env.VITE_APP_MODE === 'pq4'
  ? lazy(() => import('./pq/PqStandalone'))
  : lazy(() => import('./V4App'));
import { V4LoginGate } from './LoginGate';
import { V4ErrorBoundary } from './ErrorBoundary';

// Forward the operator's Google ID token to API calls. Before any request fires.
installGoogleApiAuth();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <V4ErrorBoundary>
      <GoogleOAuthProvider clientId={appConfig.googleClientId}>
        <GoogleAuthProvider allowedDomain={appConfig.allowedGoogleDomain}>
          <V4LoginGate>
            <BrowserRouter>
              <ToastProvider>
                <Suspense fallback={null}><Root /></Suspense>
                {/* Shared modules (CRIO session manager) report through react-hot-toast. */}
                <Toaster position="bottom-left"
                         toastOptions={{ style: { background: 'var(--ds-navy)', color: 'var(--ds-surface)',
                                                  font: 'inherit', fontSize: 'var(--ds-fs-small)' } }} />
              </ToastProvider>
            </BrowserRouter>
          </V4LoginGate>
        </GoogleAuthProvider>
      </GoogleOAuthProvider>
    </V4ErrorBoundary>
  </React.StrictMode>,
);
